import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { Funnel, ProductResponse, QuotesResponse, ResponseDetails } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { useNotificationStore } from '@/stores/notifications';


export type DTO1 = {
    page: number;
    perPage: number;
    search?: string;
    filter?: any;
    isArchived?: boolean;
    funnelId?: any;
};

export const getQuotelList = (
    {  page, perPage, search, filter , isArchived, funnelId}: DTO1 = {
      page: 1,
      perPage: 20,
    }
  ): Promise<QuotesResponse> => {
    return axios.post(`/superAdmin/get-quote-list`,  {
      page,
      perPage,
      search,
      funnelId
     });
  };


type UseOptions = {
  config?: MutationConfig<typeof getQuotelList>;
};

export const useGetQuoteList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getQuotelList,
  });
};

export type requestDTO = {
    id?: any;
    title: string;
    paymentTerms: string;
    requestedPrice: any;
    productDetails?: any;
    deliveryTime: any;
    otherDetails?: any;
    funnelId: any;
    instituteId?:any;
    advPercent?: any;
    pdaPercent?: any;
    fnfPercent?: any;
    fnfTimeline?: any;
};

export const updateQuote = ({ id,instituteId,title, paymentTerms, requestedPrice,deliveryTime, otherDetails,funnelId, productDetails, advPercent, pdaPercent, fnfPercent, fnfTimeline }: requestDTO) => {

    return axios.post(`/superadmin/create-quote`, {id,instituteId, title, paymentTerms, requestedPrice,deliveryTime, otherDetails,funnelId, productDetails, advPercent, pdaPercent, fnfPercent, fnfTimeline });

};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateQuote>;
};

export const useCreateQuote = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Quote requested successfully',
      });
    },
    ...config,
    mutationFn: updateQuote,
  });
};





export type DTO11 = {
  id: number;
}

export const getQuoteDetail = (
  {  id }: DTO11 
): Promise<ResponseDetails> => {
  return axios.post(`/marketing/get-quote-detail/${id}`);
};


type UseOptionss = {
config?: MutationConfig<typeof getQuoteDetail>;
};

export const useGetQuoteDetails= ({ config }: UseOptionss = {}) => {
return useMutation({
  ...config,
  mutationFn: getQuoteDetail,
});
};
